export enum PaymentMethod {
	CreditCard = 1,
	ApplePay,
	GooglePay,
}
